import React, { useEffect, useState } from "react";
import ProjectWebhooksForm from "./ProjectWebhooksForm";
import ProjectWebhooksList from "./ProjectWebhooksList";
import axios from "axios";
import userAuthenticationConfig from "../../../../../utils/userAuthenticationConfig";

import { StyledProjectWebhooks } from "../styledProjectDetails";
import Notification from "../../../../elements/notification/Notification";
import { checkFilterItem, fetchFilterData } from "../../../../../utils/fetchFilterData";
import { useHistory } from "react-router-dom";

const ProjectWebhooksContainer = ({ t, projectId }) => {
  const history = useHistory();

  const [actionList, setActionList] = useState();

  const [notification, setNotification] = useState({
    visible: false,
    type: "",
    message: ""
  });

  const [filterData, setFilterData] = useState({
    "currentTab": checkFilterItem(history, "currentTab", "webhooks", false, true),
  });

  const fetchActionList = () => {
    let filterUrl = fetchFilterData(filterData);
    history.replace(filterUrl);

    axios.get("/api/actions?project.id=" + projectId, userAuthenticationConfig()).then(response => {
      if (response.status === 200) {
        setActionList(response.data["hydra:member"]);
      }
    }).catch(error => {
      setNotification({ ...notification, visible: true, type: "error", message: error.response.data.message });
    });
  };

  useEffect(() => {
    fetchActionList();
  }, []);

  return (
    <>
      <Notification
        notification={notification}
        setNotification={setNotification}
      />
      <StyledProjectWebhooks>
        <ProjectWebhooksForm
          t={t}
          projectId={projectId}
          fetchActionList={fetchActionList}
        />
        <ProjectWebhooksList
          t={t}
          actionsList={actionList}
          projectId={projectId}
          fetchActionList={fetchActionList}
        />
      </StyledProjectWebhooks>
    </>
  );
};

export default ProjectWebhooksContainer;